import { styled } from "theme/default/styled";

export const SResetPasswordSendButtonLoader = styled.div`
  margin-top: 10px;
`;
